'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
        choices: [],
        min: undefined,
        max: undefined,
    });

    if (config.required && (_.isNil(input) || input.length === 0)) {
        throw new ParserError(PARSER_ERRORS.REQUIRED);
    }

    const choices = _(config.choices).keyBy('id').at(input).compact().value();

    if (choices.length !== input.length) {
        throw new ParserError(PARSER_ERRORS.INVALID_CHOICE);
    }

    if (config.required || (!config.required && choices.length > 0)) {
        if (_.isNumber(config.min) && choices.length < config.min) {
            throw new ParserError(PARSER_ERRORS.MIN_CHOICES, [{min: config.min}]);
        }

        if (_.isNumber(config.max) && choices.length > config.max) {
            throw new ParserError(PARSER_ERRORS.MAX_CHOICES, [{max: config.max}]);
        }
    }

    return _.map(choices, 'id');
};
